import styles from '../styles/BasicFormInput.module.css';

export default function BasicFormInput({
  label,
  updateKey,
  value,
  onChange,
  disabled = false,
  placeholder = '',
  className
}) {
  return (
    <div className={styles.inputContainer}>
      <label htmlFor={`${updateKey}-input`} className={styles.label}>
        {label}
      </label>
      <input
        placeholder={placeholder}
        disabled={disabled}
        required={label[0] === '*'}
        name={`${updateKey}`}
        id={`${updateKey}}-input`}
        value={value}
        onChange={onChange}
        className={`${styles.input} ${className}`}
      />
    </div>
  );
}
